import React, { useEffect } from "react";
import { Button, Form, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { userForgetPassword } from "../appRedux/actions/Auth";
import { authConstants } from "../constants";
import { getUserDetails, showMessage } from "../helpers";
import "./ResetPassword.css";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isMailSend } = useSelector(({ authentication }) => authentication);

  useEffect(() => {
    if (getUserDetails() !== "") {
      showMessage("info", "Access Denied!");
      navigate("/logout");
    }

    return () => {
      dispatch({ type: authConstants.FORGOT_PASSWORD_REQUEST });
    };
  }, []);

  useEffect(() => {
    if (isMailSend) {
      navigate("/login");
    }
  }, [isMailSend]);

  const onFinish = (values) => {
    dispatch(
      userForgetPassword({
        email: values.email.trim().toLowerCase(),
      }),
    );
  };

  return (
    <div className="reset-password-container">
      <div className="reset-password-content">


        <div className="reset-password-form">
        <div className="logo-container">
          <img
            src={require("assets/images/logo-white.png")}
            alt="Medicines Patent Pool"
            className="mpp-logo"
          />
        </div>
          <h1 className="reset-password-title">Forgot your password?</h1>
          <p className="description">
            Don't worry. Recovering the password is easy. Just tell the email you have registered with.
          </p>

          <Form
            name="resetPassword"
            onFinish={onFinish}
            layout="vertical"
            className="reset-form"
          >
            <Form.Item
              label="E-mail Address"
              name="email"
              rules={[
                { required: true, message: "Please input your email!" },
                { type: "email", message: "Please enter a valid email address!" }
              ]}
            >
              <Input
                placeholder="Enter your Email ID"
                className="email-input"
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" className="send-button">
                SEND
              </Button>
            </Form.Item>
          </Form>

          <div className="bottom-links">
            <Link to="/login" className="back-link">Go back to login</Link>
            <div className="signup-prompt">
              Don't have an account? <Link to="/signup" className="signup-link">Sign up</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
